(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bioskyn-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.ready) return; root.dataset.ready='1';
    var nav=root.querySelector('[data-bsp-nav]');
    function headerOffset(){
      var t=0;
      document.querySelectorAll('.shopify-section-group-header-group, header-component, .header, #header-component').forEach(function(el){
        var cs=getComputedStyle(el);
        if(cs.position==='sticky'||cs.position==='fixed'){var r=el.getBoundingClientRect(); if(r.top<=1&&r.bottom>t) t=r.bottom;}
      });
      root.style.setProperty('--bsp-top',Math.max(0,Math.round(t))+'px');
    }
    headerOffset(); window.addEventListener('resize',headerOffset); window.addEventListener('scroll',function(){window.requestAnimationFrame(headerOffset);},{passive:true});
    var links=root.querySelectorAll('.bsp-jump a');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){links.forEach(function(l){var on=l.dataset.target===en.target.id;l.classList.toggle('on',on);if(on&&nav){var inner=nav.firstElementChild;inner.scrollTo({left:l.offsetLeft-inner.clientWidth/2+l.clientWidth/2,behavior:'smooth'});}});}});},{rootMargin:'-40% 0px -55% 0px'});
      root.querySelectorAll('.bsp-group').forEach(function(g){io.observe(g);});
    }
    root.querySelectorAll('.bsp-slides').forEach(function(sl){
      var dots=sl.parentElement.querySelectorAll('.bsp-dots i');
      if(!dots.length) return;
      sl.addEventListener('scroll',function(){var i=Math.round(sl.scrollLeft/sl.clientWidth);dots.forEach(function(d,n){d.classList.toggle('on',n===i);});},{passive:true});
    });
    root.addEventListener('click',function(e){
      var arrow=e.target.closest('.bsp-arrow');
      if(arrow){var sl=arrow.parentElement.querySelector('.bsp-slides');var dir=arrow.classList.contains('bsp-next')?1:-1;var max=sl.scrollWidth-sl.clientWidth;var next=sl.scrollLeft+dir*sl.clientWidth;if(next>max+2)next=0;if(next<-2)next=max;sl.scrollTo({left:next});return;}
      var q=e.target.closest('.bsp-quick');
      if(q){openQuick(q.dataset.quick);}
    });
    var dlg=root.querySelector('.bsp-dialog');
    var current=null;
    function openQuick(handle){
      var src=root.querySelector('[data-quick-json="'+handle+'"]'); if(!src||!dlg) return;
      var d=JSON.parse(src.textContent); current=d;
      dlg.querySelector('#bsp-dlg-title').textContent=d.title;
      dlg.querySelector('.bsp-dlg-type').textContent=d.type||'';
      dlg.querySelector('.bsp-dlg-price').textContent=d.price;
      dlg.querySelector('.bsp-dlg-desc').textContent=d.desc||'';
      dlg.querySelector('.bsp-dlg-link').href=d.url;
      dlg.querySelector('.bsp-dlg-note').textContent='';
      var add=dlg.querySelector('.bsp-dlg-add'); add.disabled=!d.available; add.textContent=d.available?'Add to bag':'Sold out';
      var main=dlg.querySelector('.bsp-dlg-main'); var thumbs=dlg.querySelector('.bsp-dlg-thumbs');
      main.replaceChildren(); thumbs.replaceChildren();
      function show(i){var img=document.createElement('img');img.src=d.images[i];img.alt=d.title;main.replaceChildren(img);thumbs.querySelectorAll('button').forEach(function(b,n){b.classList.toggle('on',n===i);});}
      (d.images||[]).forEach(function(u,i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Photo '+(i+1));var im=document.createElement('img');im.src=u;im.alt='';b.append(im);b.addEventListener('click',function(){show(i);});thumbs.append(b);});
      if(d.images&&d.images.length) show(0);
      if(!d.images||d.images.length<2) thumbs.replaceChildren();
      dlg.showModal();
    }
    if(dlg){
      dlg.querySelector('.bsp-dlg-close').addEventListener('click',function(){dlg.close();});
      dlg.addEventListener('click',function(e){if(e.target===dlg) dlg.close();});
      dlg.querySelector('.bsp-dlg-add').addEventListener('click',function(){
        if(!current) return; var btn=this; var note=dlg.querySelector('.bsp-dlg-note'); btn.disabled=true; btn.textContent='Adding...';
        var root_url=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(root_url+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(current.variant),quantity:1}]})})
          .then(function(r){if(!r.ok) throw new Error();btn.textContent='Added';note.innerHTML='';var a=document.createElement('a');a.href=root_url+'cart';a.textContent='View bag';a.style.textDecoration='underline';note.append(a);})
          .catch(function(){btn.disabled=false;btn.textContent='Add to bag';note.textContent='Something went wrong. Please try again.';});
      });
    }
  }
  document.querySelectorAll('[data-bsp]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-bsp]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bioskyn-skin-quiz"] && !Shopify.designMode) return;
  try {
    
function bioskynRoutine(answers) {
  const [skin, concern, reaction, actives, context] = answers;
  const flags = context.filter(value => value !== 'none').map(value => 'hold_' + value);
  if (actives === 'rx') flags.push('hold_rx');
  if (reaction === 'active') flags.push('hold_irritation');
  const oily = skin === 'oily' || skin === 'combination';
  const dry = skin === 'dry';
  const sensitive = reaction === 'sometimes' || reaction === 'frequent' || reaction === 'active' || concern === 'comfort';
  const cleanser = oily ? 'gentle-foaming-cleanser' : 'aquaderm-ha-cleanser';
  const moisturizer = 'kyria-creme';
  const barrierSerum = sensitive ? 'arnica-soothing-complex' : dry ? 'ceramide-skyn-elixir' : 'b5-hydrating-complex';
  let serums, title;
  let reasons = [oily ? 'reason_oily' : dry ? 'reason_dry' : 'reason_normal'];
  const intro = ['intro_general'];
  if (flags.length) {
    serums = [[barrierSerum, 'both']]; title = 'hold_title';
    reasons = ['hold_intro', ...flags]; intro.push('intro_sensitive');
  } else if (sensitive) {
    serums = [[barrierSerum, 'both']]; title = 'sensitive_title';
    reasons.push('reason_sensitive'); intro.push('intro_sensitive');
  } else if (actives !== 'none') {
    serums = [[dry ? 'ceramide-skyn-elixir' : 'b5-hydrating-complex', 'both']]; title = 'existing_title';
    reasons.push('reason_existing'); intro.push('intro_existing');
  } else if (concern === 'breakouts') {
    serums = [['luminique-b3-complex', 'am'], ['azelaic-illuminating-complex', 'pm']]; title = 'breakouts_title';
    reasons.push('reason_breakouts'); intro.push('intro_azelaic');
  } else if (concern === 'tone') {
    serums = [['luminique-b3-complex', 'am'], ['azelaic-illuminating-complex', 'pm']]; title = 'tone_title';
    reasons.push('reason_tone'); intro.push('intro_azelaic');
  } else if (concern === 'lines') {
    serums = [['revive-phyto-retinol-serum', 'pm']]; title = 'lines_title';
    reasons.push('reason_lines'); intro.push('intro_revive');
  } else {
    serums = [[dry ? 'ceramide-skyn-elixir' : 'b5-hydrating-complex', 'both']]; title = 'hydration_title';
    reasons.push('reason_hydration');
  }
  return {cleanser, moisturizer, serums, products: [cleanser, ...serums.map(s => s[0]), moisturizer], title, reasons, intro};
}
class BioSkynRoutineQuiz extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.words = JSON.parse(this.querySelector('[data-quiz-translations]').textContent);
    this.questions = [
      {values:['dry','oily','combination','balanced','unsure']},
      {values:['tone','breakouts','lines','hydration','comfort']},
      {values:['rare','sometimes','frequent','active']},
      {values:['none','cosmetic','rx','unsure']},
      {values:['none','pregnancy','allergy','procedure','private'],multiple:true}
    ];
    this.total = this.questions.length;
    this.answers = Array.from({length:this.total}, () => []);
    this.position = 0;
    this.form = this.querySelector('.sq-form');
    this.panel = this.querySelector('.sq-question');
    this.results = this.querySelector('.sq-results');
    this.querySelector('[data-start]').addEventListener('click',()=>this.showQuestion());
    this.querySelector('[data-back]').addEventListener('click',()=>{if(this.position>0){this.position--;this.showQuestion();}});
    this.form.addEventListener('submit',event=>{
      event.preventDefault();
      if (!this.answers[this.position].length) {
        this.querySelector('.sq-error').textContent=this.words.required;
        this.panel.querySelector('input').focus();
        return;
      }
      if (this.position===this.total-1) this.showResults();
      else {this.position++;this.showQuestion();}
    });
    this.querySelector('[data-edit]').addEventListener('click',()=>{this.position=0;this.showQuestion();});
    this.querySelector('[data-restart]').addEventListener('click',()=>{
      this.answers=Array.from({length:this.total},()=>[]);
      this.position=0;
      this.querySelector('[data-products]').replaceChildren();
      this.showQuestion();
    });
    this.querySelector('[data-print]').addEventListener('click',()=>window.print());
    this.querySelector('[data-kit-add]').addEventListener('click',()=>this.addKit());
  }
  node(tag,text,className) {
    const element=document.createElement(tag);
    if(text) element.textContent=text;
    if(className) element.className=className;
    return element;
  }
  money(cents) {
    const currency=this.dataset.currency||'CAD';
    try { return new Intl.NumberFormat('en-CA',{style:'currency',currency}).format(cents/100); } catch(e) { return '$'+(cents/100).toFixed(2); }
  }
  showQuestion() {
    this.dataset.state='questions';
    this.querySelector('.sq-welcome').hidden=true;
    this.form.hidden=false;
    this.results.hidden=true;
    this.querySelector('.sq-error').textContent='';
    const index=this.position+1;
    const question=this.questions[this.position];
    const progress=this.words.step.replace('{current}',index).replace('{total}',this.total);
    this.querySelector('.sq-progress-text').textContent=progress;
    this.querySelector('progress').value=index;
    this.querySelector('progress').setAttribute('aria-label',progress);
    this.querySelector('[data-back]').disabled=this.position===0;
    this.querySelector('[data-next]').textContent=this.position===this.total-1?this.words.results:this.words.continue;
    const fieldset=this.node('fieldset');
    const legend=this.node('legend',this.words['q'+index]);
    legend.id='sq-legend-'+this.dataset.section;
    fieldset.append(legend);
    this.panel.setAttribute('aria-labelledby',legend.id);
    fieldset.append(this.node('p',this.words['q'+index+'_hint']+' '+this.words[question.multiple?'choose_many':'choose_one'],'sq-hint'));
    const choices=this.node('div',null,'sq-choices');
    question.values.forEach(value=>{
      const label=this.node('label',null,'sq-choice');
      const input=this.node('input');
      input.type=question.multiple?'checkbox':'radio';
      input.name='sq-question-'+index;
      input.value=value;
      input.checked=this.answers[this.position].includes(value);
      input.addEventListener('change',()=>{
        if(question.multiple) {
          if(input.checked && (value==='none'||value==='private')) choices.querySelectorAll('input').forEach(other=>{if(other!==input)other.checked=false;});
          else if(input.checked) choices.querySelectorAll('input[value="none"],input[value="private"]').forEach(other=>other.checked=false);
        }
        this.answers[this.position]=Array.from(choices.querySelectorAll('input:checked'),entry=>entry.value);
        this.querySelector('.sq-error').textContent='';
      });
      label.append(input,this.node('span',this.words['q'+index+'_'+value]));
      choices.append(label);
    });
    fieldset.append(choices);
    this.panel.replaceChildren(fieldset);
    this.panel.focus({preventScroll:true});
    this.panel.scrollIntoView({block:'center',behavior:'instant'});
  }
  showResults() {
    const answers=this.answers.map((answer,index)=>index===4?answer:answer[0]);
    const result=bioskynRoutine(answers);
    this.dataset.state='results';
    this.form.hidden=true;
    this.results.hidden=false;
    this.querySelector('[data-result-title]').textContent=this.words[result.title];
    this.querySelector('[data-reasons]').replaceChildren(...result.reasons.map(key=>this.node('p',this.words[key])));
    this.querySelector('[data-intro]').replaceChildren(...result.intro.map(key=>this.node('p',this.words[key])));
    const template=handle=>this.querySelector('template[data-product="'+handle+'"]');
    const am=this.querySelector('[data-am]');
    const pm=this.querySelector('[data-pm]');
    am.replaceChildren();pm.replaceChildren();
    const step=(list,handle,copyKey,fallbackKey)=>{
      const item=this.node('li');
      const product=handle?template(handle):null;
      if(product){const link=this.node('a',product.dataset.title);link.href=product.dataset.url;item.append(link);}
      else item.append(this.node('strong',this.words[fallbackKey]));
      item.append(this.node('p',this.words[copyKey]));
      list.append(item);
    };
    step(am,result.cleanser,'cleanser_step');
    result.serums.forEach(([h,w])=>{if(w==='am'||w==='both')step(am,h,'serum_step');});
    step(am,result.moisturizer,'moisturizer_step');
    step(am,null,'spf_copy','spf_name');
    step(pm,result.cleanser,'cleanser_step');
    result.serums.forEach(([h,w])=>{if(w==='pm'||w==='both')step(pm,h,'serum_step');});
    step(pm,result.moisturizer,'moisturizer_step');
    const roles={[result.cleanser]:'cleanser_tag',[result.moisturizer]:'moisturizer_tag'};
    result.serums.forEach(([h,w])=>{roles[h]=result.serums.length>1?(w==='am'?'am_tag':'pm_tag'):'serum_tag';});
    const products=this.querySelector('[data-products]');
    products.replaceChildren();
    let total=0, allAvailable=true;
    const names=[];
    this.kitVariants=[];
    result.products.forEach(handle=>{
      const source=template(handle);
      if(!source){allAvailable=false;return;}
      const content=source.content.cloneNode(true);
      content.querySelector('[data-role]').textContent=this.words[roles[handle]];
      products.append(content);
      names.push(source.dataset.title);
      total+=Number(source.dataset.price)||0;
      if(source.dataset.available==='true') this.kitVariants.push(source.dataset.variant); else allAvailable=false;
    });
    const percent=Number(this.dataset.kitPercent)||0;
    this.querySelector('[data-kit-names]').textContent=names.join(' + ');
    this.querySelector('[data-kit-total]').textContent=this.words.kit_total.replace('{total}',this.money(total));
    this.querySelector('[data-kit-save]').textContent=percent>0&&this.dataset.kitCode?this.words.kit_save.replace('{kit}',this.money(Math.round(total*(100-percent)/100))).replace('{percent}',percent):'';
    this.querySelector('[data-kit-add]').disabled=!allAvailable;
    this.querySelector('[data-kit-note]').textContent=allAvailable?'':this.words.kit_sold_out;
    const title=this.querySelector('[data-result-title]');
    title.focus({preventScroll:true});
    title.scrollIntoView({block:'start',behavior:'instant'});
  }
  async addKit() {
    const button=this.querySelector('[data-kit-add]');
    const note=this.querySelector('[data-kit-note]');
    if(!this.kitVariants||!this.kitVariants.length) return;
    button.disabled=true;
    note.textContent=this.words.kit_adding;
    const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:this.kitVariants.map(id=>({id:Number(id),quantity:1}))})});
      if(!response.ok) throw new Error('add failed');
      const code=this.dataset.kitCode;
      window.location.href=code?root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(root+'cart'):root+'cart';
    } catch(error) {
      note.textContent=this.words.kit_error;
      button.disabled=false;
    }
  }
}
if(!customElements.get('skin-routine-quiz'))customElements.define('skin-routine-quiz',BioSkynRoutineQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
